import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { BASE_ROUTE } from './config';

ReactDOM.render(
    <React.StrictMode>
        <BrowserRouter basename={BASE_ROUTE}>
            <App />
        </BrowserRouter>
    </React.StrictMode>,
    document.getElementById('catalog-root')
);
